export const FALLBACK_OTHER_ACCOUNTING_SOFTWARE_ID = "-1";

export const getOtherAccountingSoftwareId = (options) => {
    const other = (Array.isArray(options) ? options : []).find(
        (o) =>
            typeof o?.name === "string" &&
            o.name.trim().toLowerCase() === "other"
    );

    return other
        ? String(other.id)
        : FALLBACK_OTHER_ACCOUNTING_SOFTWARE_ID;
};

export const isOtherAccountingSoftware = (id, options) =>
    id !== "" &&
    id != null &&
    String(id) === getOtherAccountingSoftwareId(options);

export const buildAccountingSoftwareOptions = (dropdown) => {
    const options = Array.isArray(dropdown) ? dropdown : [];
    const otherId = getOtherAccountingSoftwareId(options);
    const other = options.find(
        (option) => String(option?.id) === otherId
    );

    return [
        ...options
            .filter(
                (option) =>
                    typeof option?.name !== "string" ||
                    option.name.trim().toLowerCase() !== "other"
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((item) => ({
                value: String(item.id),
                label: item.name,
            })),
        {
            value: other ? String(other.id) : FALLBACK_OTHER_ACCOUNTING_SOFTWARE_ID,
            label: "Other",
        },
    ];
};

export const validateCompanyDetails = (
    formData,
    accountingSoftwareOptions = []
) => {
    const errors = {};

    if (!formData.companyName) {
        errors.companyName =
            "Company name is required. If this field is incorrect or empty, please contact support.";
    }
    if (!formData.abn) {
        errors.abn =
            "ABN is required. If this field is incorrect, please contact support.";
    }
    if (!formData.companyTypeId) {
        errors.companyTypeId = "Please select an entity type.";
    }
    if (!formData.numberOfEmployees) {
        errors.numberOfEmployees = "Number of employees is required.";
    }
    if (formData.payrollFrequency === "Bi-Monthly") {
        if (!formData.payrollDayOfMonth1) {
            errors.payrollDayOfMonth1 =
                "Please select a first day of the month.";
        }
        if (!formData.payrollDayOfMonth2) {
            errors.payrollDayOfMonth2 =
                "Please select a second day of the month.";
        }
    }
    if (
        ["Monthly", "Fortnightly", "Weekly"].includes(
            formData.payrollFrequency
        )
    ) {
        if (!formData.nextPayrollAt) {
            errors.nextPayrollAt = "Please select a next payment date.";
        } else if (new Date(formData.nextPayrollAt) < new Date()) {
            errors.nextPayrollAt =
                "Next payment date must be in the future.";
        }
    }
    if (!formData.accountingSoftwareID) {
        errors.accountingSoftwareID =
            "Please select an accounting software.";
    } else if (
        isOtherAccountingSoftware(
            formData.accountingSoftwareID,
            accountingSoftwareOptions
        ) &&
        !formData.otherAccountingSoftware
    ) {
        errors.otherAccountingSoftware =
            "Please enter an accounting software.";
    }

    return errors;
};
